import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';

export const SharedListItemStyles = css`
  display: flex;
  align-items: center;
  padding: ${layout.measurements.spacing050};
  cursor: pointer;
  width: 100%;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  svg {
    margin-right: ${layout.measurements.spacing050};
  }

  &:hover {
    background: ${p => p.theme.dropdowns.secondary.hoverBackground};
  }
`;

export const ListItem = styled(Clickable)`
  ${SharedListItemStyles};
`;
